module.exports = __webpack_public_path__ + "img/ic_access.7499593b.svg";